export interface IPodiumItem {
  name: string;
  tooltip: string;
}

interface IPodiumColor {
  fromColor: string;
  toColor: string;
}

export interface IPodiumColors {
  first: IPodiumColor;
  second: IPodiumColor;
  third: IPodiumColor;
}

export const DEFAULT_PODIUM_COLORS: IPodiumColors = {
  first: {
    fromColor: "from-teal-200",
    toColor: "to-teal-400",
  },
  second: {
    fromColor: "from-cyan-300",
    toColor: "to-cyan-500",
  },
  third: {
    fromColor: "from-sky-300",
    toColor: "to-sky-500",
  },
};

export const MONOSITE_PODIUM_COLORS: IPodiumColors = {
  first: {
    fromColor: "from-blue-200",
    toColor: "to-blue-400",
  },
  second: {
    fromColor: "from-blue-400",
    toColor: "to-blue-600",
  },
  third: {
    fromColor: "from-blue-500",
    toColor: "to-blue-700",
  },
};
